module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-additional-integrations-220d7176efd21c9665ef645f58cf84da.png";